import { useCallback } from "react";
import api from "./authAxios";
import { endpoints } from "./endpoints"; // Ensure the path is correct

const useNetworkServices = () => {
  const apiWithAuth = api;

  const signInAdmin = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.SIGNIN, data);
    },
    [apiWithAuth]
  );

  const ForgotPassword = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.FORGOTPASSWORD, data);
    },
    [apiWithAuth]
  );

  const OTPVerification = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.OTPVERIFICATION, data);
    },
    [apiWithAuth]
  );

  const ResendOTP = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.RESENDOTP, data);
    },
    [apiWithAuth]
  );

  const ResetPassword = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.RESETPASSWORD, data);
    },
    [apiWithAuth]
  );

  const Dashboard = useCallback(
    async (params) => {
      return apiWithAuth.get(endpoints.DASHBOARD, { params: params });
    },
    [apiWithAuth]
  );

  const merchantList = useCallback(async () => {
    return apiWithAuth.get(endpoints.MERCHANTLIST);
  }, [apiWithAuth]);

  const merchantKycList = useCallback(
    async (params) => {
      return apiWithAuth.get(endpoints.MERCHANTKYCLIST, { params: params });
    },
    [apiWithAuth]
  );

  const CashfuseCustomers = useCallback(async () => {
    return apiWithAuth.get(endpoints.CASHFUSECUSTOMER);
  }, [apiWithAuth]);

  const kycVerify = useCallback(
    async (data) => {
      return apiWithAuth.patch(endpoints.KYCVERIFY, data);
    },
    [apiWithAuth]
  );

  const queryUpdate = useCallback(
    async (id) => {
      return apiWithAuth.patch(endpoints.UPDATEQUERY(id));
    },
    [apiWithAuth]
  );

  const generalEnquiries = useCallback(async () => {
    return apiWithAuth.get(endpoints.GENERALENQUIRIES);
  }, [apiWithAuth]);

  const merchantStatus = useCallback(
    async (queryString) => {
      return apiWithAuth.patch(endpoints.MERCHANTSTATUS(queryString));
    },
    [apiWithAuth]
  );

  const offerCardStatus = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.OFFERCARDSTATUS, data);
    },
    [apiWithAuth]
  );

  const bannerOfferList = useCallback(async () => {
    return apiWithAuth.get(endpoints.BANNEROFFERLIST);
  }, [apiWithAuth]);

  const bannerCardStatus = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.BANNERCARDOFFER, data);
    },
    [apiWithAuth]
  );
  const customerList = useCallback(async (queryString) => {
    return apiWithAuth.get(endpoints.CUSTOMERLIST(queryString));
  }, [apiWithAuth]);

  const UpdateProfile = useCallback(
    async (data) => {
      return apiWithAuth.patch(endpoints.UPDATEPROFILE, data);
    },
    [apiWithAuth]
  );
  const merchantTransactionList = useCallback(async () => {
    return apiWithAuth.get(endpoints.MERCHANTTRANSACTIONLIST);
  }, [apiWithAuth]);

  const Categorylist = useCallback(async () => {
    return apiWithAuth.get(endpoints.CATEGORYLIST);
  }, [apiWithAuth]);
  const profileDetail = useCallback(async () => {
    return apiWithAuth.get(endpoints.GETPROFILE);
  }, [apiWithAuth]);
  const ContactUsData = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.CONTACTUS, data);
    },
    [apiWithAuth]
  );
  const AddCashOffer = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.ADDOFFER, data);
    },
    [apiWithAuth]
  );
  const GetCashOffer = useCallback(async () => {
    return apiWithAuth.get(endpoints.GETOFFER);
  }, [apiWithAuth]);
  const TreamCondation = useCallback(
    async (data) => {
      console.log(data, "data");

      return apiWithAuth.post(endpoints.TERMSCONDATION, data);
    },
    [apiWithAuth]
  );
  const GetTreams = useCallback(async () => {
    return apiWithAuth.get(endpoints.GETTREAM);
  }, [apiWithAuth]);
  const AddFaqs = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.AddFAQ, data);
    },
    [apiWithAuth]
  );
  const Getfaqs = useCallback(async () => {
    return apiWithAuth.get(endpoints.GETFAQ);
  }, [apiWithAuth]);
  const AddofferUpdate = useCallback(
    async (data) => {
      return apiWithAuth.patch(endpoints.ADDOFFERUPDATE, data);
    },
    [apiWithAuth]
  );
  const AddBanner = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.ADDBANNER, data);
    },
    [apiWithAuth]
  );
  const GetBanner = useCallback(async () => {
    return apiWithAuth.get(endpoints.GETBANNER);
  }, [apiWithAuth]);
  const AddBannerUpload = useCallback(
    async (data) => {
      return apiWithAuth.patch(endpoints.ADDBANNERUODATE, data);
    },
    [apiWithAuth]
  );
  const OfferManagement = useCallback(async () => {
    return apiWithAuth.get(endpoints.OfferManagement);
  }, [apiWithAuth]);

  const CreateCategory = useCallback(
    async (data) => {
      return apiWithAuth.post(endpoints.CreateCategory, data);
    },
    [apiWithAuth]
  );

  const GetAllCategory = useCallback(async () => {
    return apiWithAuth.get(endpoints.GetAllCategor);
  }, [apiWithAuth]);

  return {
    signInAdmin,
    ForgotPassword,
    OTPVerification,
    ResendOTP,
    ResetPassword,
    Dashboard,
    merchantList,
    merchantKycList,
    CashfuseCustomers,
    kycVerify,
    queryUpdate,
    generalEnquiries,
    merchantStatus,
    offerCardStatus,
    bannerOfferList,
    bannerCardStatus,
    customerList,
    UpdateProfile,
    merchantTransactionList,
    profileDetail,
    Categorylist,
    ContactUsData,
    AddCashOffer,
    GetCashOffer,
    TreamCondation,
    GetTreams,
    AddFaqs,
    Getfaqs,
    AddofferUpdate,
    AddBanner,
    GetBanner,
    AddBannerUpload,
    OfferManagement,
    CreateCategory,
    GetAllCategory,
  };
};

export default useNetworkServices;
